import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
axios.defaults.withCredentials = true;

// Modulo consensi GDPR aperto dalla cliente col QR del centro (pubblico, senza login)
export const consentApi = {
  get: (token) => axios.get(`${BASE}/public/consent/${token}`).then((r) => r.data),
  submit: (token, selections) =>
    axios.post(`${BASE}/public/consent/${token}`, { selections }).then((r) => r.data),
};

// All these are tenant-scoped. `slug` is the centro slug from URL.
export const tApi = (slug) => {
  const T = `${BASE}/tenants/${slug}`;
  return {
    info: () => axios.get(`${T}/info`).then((r) => r.data),
    publicInfo: () => axios.get(`${BASE}/public/tenants/${slug}`).then((r) => r.data),
    listServices: () => axios.get(`${T}/services`).then((r) => r.data),
    // pannello staff: anche i trattamenti spenti, per poterli riattivare
    listAllServices: () => axios.get(`${T}/services/all`).then((r) => r.data),
    createService: (d) => axios.post(`${T}/services`, d).then((r) => r.data),
    updateService: (id, d) => axios.patch(`${T}/services/${id}`, d).then((r) => r.data),
    myAppointments: () => axios.get(`${T}/appointments/mine`).then((r) => r.data),
    allAppointments: () => axios.get(`${T}/appointments`).then((r) => r.data),
    book: (service_id, starts_at, notes, staff_id) =>
      axios.post(`${T}/appointments`, { service_id, starts_at, notes, ...(staff_id ? { staff_id } : {}) }).then((r) => r.data),
    cancelAppt: (id) => axios.post(`${T}/appointments/${id}/cancel`).then((r) => r.data),
    completeAppt: (id) => axios.post(`${T}/appointments/${id}/complete`).then((r) => r.data),
    myTreatments: () => axios.get(`${T}/treatments/mine`).then((r) => r.data),
    addTreatment: (d) => axios.post(`${T}/treatments`, d).then((r) => r.data),
    myFidelity: () => axios.get(`${T}/fidelity/mine`).then((r) => r.data),
    listClients: () => axios.get(`${T}/clients`).then((r) => r.data),
    myWallet: () => axios.get(`${T}/wallet/mine`).then((r) => r.data),
    redeem: (code) => axios.post(`${T}/wallet/redeem`, { code }).then((r) => r.data),
    createGiftcard: (amount, note) =>
      axios.post(`${T}/giftcards`, { amount, note }).then((r) => r.data),
    listGiftcards: () => axios.get(`${T}/giftcards`).then((r) => r.data),
    availability: (service_id, date, staff_id) =>
      axios.get(`${T}/availability`, { params: { service_id, date, ...(staff_id ? { staff_id } : {}) } }).then((r) => r.data),
    team: (service_id) =>
      axios.get(`${T}/team`, { params: service_id ? { service_id } : {} }).then((r) => r.data),
    getSettings: () => axios.get(`${T}/settings`).then((r) => r.data),
    updateSettings: (d) => axios.patch(`${T}/settings`, d).then((r) => r.data),
    listStaff: () => axios.get(`${T}/staff`).then((r) => r.data),
    createStaff: (d) => axios.post(`${T}/staff`, d).then((r) => r.data),
    updateStaff: (uid, d) => axios.patch(`${T}/staff/${uid}`, d).then((r) => r.data),
    resetStaffPassword: (uid) => axios.post(`${T}/staff/${uid}/reset-password`).then((r) => r.data),
    deleteStaff: (uid) => axios.delete(`${T}/staff/${uid}`).then((r) => r.data),
    // operatrici sincronizzate dal gestionale: orari per le prenotazioni online
    listOperators: () => axios.get(`${T}/operators`).then((r) => r.data),
    updateOperator: (id, d) => axios.patch(`${T}/operators/${id}`, d).then((r) => r.data),
  };
};

// Cambio password del proprio account (qualunque ruolo)
export const changeOwnPassword = (current_password, new_password) =>
  axios.post(`${BASE}/auth/password`, { current_password, new_password }).then((r) => r.data);

// Recupero password (self-service, senza login)
export const forgotPassword = (slug, email) =>
  axios.post(`${BASE}/auth/tenants/${slug}/forgot`, { email }).then((r) => r.data);
export const resetPassword = (token, new_password) =>
  axios.post(`${BASE}/auth/reset-password`, { token, new_password }).then((r) => r.data);

// Super-admin API
export const adminApi = {
  stats: () => axios.get(`${BASE}/admin/stats`).then((r) => r.data),
  listTenants: () => axios.get(`${BASE}/admin/tenants`).then((r) => r.data),
  createTenant: (d) => axios.post(`${BASE}/admin/tenants`, d).then((r) => r.data),
  getTenant: (id) => axios.get(`${BASE}/admin/tenants/${id}`).then((r) => r.data),
  updateTenant: (id, d) => axios.patch(`${BASE}/admin/tenants/${id}`, d).then((r) => r.data),
  rotateKey: (id) => axios.post(`${BASE}/admin/tenants/${id}/api-key/rotate`).then((r) => r.data),
  resetOwnerPassword: (id) =>
    axios.post(`${BASE}/admin/tenants/${id}/reset-owner-password`).then((r) => r.data),
  setOwnerPassword: (id, password) =>
    axios.post(`${BASE}/admin/tenants/${id}/set-owner-password`, { password }).then((r) => r.data),
  tenantClients: (id) => axios.get(`${BASE}/admin/tenants/${id}/clients`).then((r) => r.data),
  deleteTenant: (id) => axios.delete(`${BASE}/admin/tenants/${id}`).then((r) => r.data),
  getAccount: () => axios.get(`${BASE}/admin/account`).then((r) => r.data),
  updateAccount: (d) => axios.patch(`${BASE}/admin/account`, d).then((r) => r.data),
  // richieste demo arrivate dal modulo della landing
  leads: () => axios.get(`${BASE}/leads`).then((r) => r.data),
  updateLead: (id, d) => axios.patch(`${BASE}/leads/${id}`, d).then((r) => r.data),
  // Voce «Aura» del gestionale: licenze che la usano, consumo, blocco e tetto personale
  voiceLicenze: (giorni = 30) =>
    axios.get(`${BASE}/admin/voice/licenze`, { params: { giorni } }).then((r) => r.data),
  voiceAggiorna: (licenseId, d) =>
    axios.patch(`${BASE}/admin/voice/licenze/${licenseId}`, d).then((r) => r.data),
  // legge una chiave di licenza incollata (il server non la salva): ID, tipo, scadenza
  voiceLeggiLicenza: (licenza) =>
    axios.post(`${BASE}/admin/voice/leggi-licenza`, { licenza }).then((r) => r.data),
};

export function fmtError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Errore";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" · ");
  return String(d);
}

export const fmtEUR = (v) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(v || 0);
// timeZone = fuso del centro (info.timezone): gli orari si leggono come in salone,
// qualunque sia il fuso del telefono. Senza, si usa quello del dispositivo.
const withTz = (opts, timeZone) => {
  if (!timeZone) return opts;
  try { new Intl.DateTimeFormat("it-IT", { timeZone }); return { ...opts, timeZone }; }
  catch (_e) { return opts; }
};
export const fmtDate = (d, timeZone) =>
  new Intl.DateTimeFormat("it-IT", withTz({ dateStyle: "long", timeStyle: "short" }, timeZone)).format(new Date(d));
export const fmtDateShort = (d, timeZone) =>
  new Intl.DateTimeFormat("it-IT", withTz({ dateStyle: "medium" }, timeZone)).format(new Date(d));

// Data di oggi (YYYY-MM-DD) nel fuso indicato, più `addDays` giorni.
// Non usa toISOString(): quella è la data UTC, sbagliata tra mezzanotte e le 2.
export const isoDateInTz = (timeZone, addDays = 0) => {
  const parts = new Intl.DateTimeFormat("en-CA", withTz(
    { year: "numeric", month: "2-digit", day: "2-digit" }, timeZone)).formatToParts(new Date());
  const get = (t) => Number(parts.find((p) => p.type === t).value);
  const d = new Date(Date.UTC(get("year"), get("month") - 1, get("day") + addDays));
  return d.toISOString().slice(0, 10);
};
